import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import InternalGate from './pages/InternalGate'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
 <React.StrictMode>
 <InternalGate><App /></InternalGate>
 </React.StrictMode>,
)
